import React from 'react';
import { enumHelper } from '../../utils';
import ENUMS from '../../enums/index';

const renderStatusColors = scheduleStatus => {
  switch (scheduleStatus) {
    case 'CONFIRMED':
      return 'text-success';
    case 'DISABLED':
      return 'text-danger';
    case 'PENDING':
      return 'text-warning';
    default:
      return 'text-muted';
  }
};

export const takeawayFinancialReport = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'نام کافه',
    dataIndex: 'cafeName',
    name: 'cafeName',
    isSortable: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_CAFE_DATES_LIST_FOR_ADMIN,
  },
  {
    title: 'تاریخ صدور فاکتور',
    dataIndex: 'startDate',
    name: 'issuingDate',
    isSortable: true,
  },
  {
    title: 'تاریخ شروع قرارداد',
    dataIndex: 'startDate',
    name: 'startDate',
    isSortable: true,
  },
  {
    title: 'تاریخ پایان قرارداد',
    dataIndex: 'endDate',
    name: 'endDate',
    isSortable: true,
  },
  {
    title: 'تاریخ سررسید پرداخت',
    dataIndex: 'dueDate',
    name: 'dueDate',
    isSortable: true,
  },
  {
    title: 'مبلغ شارژ سه ماهه',
    dataIndex: 'chargeAmountFor3Month',
    name: 'chargeAmountFor3Month',
    isSortable: false,
    render: amount => (
      <>{amount.toLocaleString()}</>
    ),
  },
  {
    title: 'وضعیت پرداخت',
    dataIndex: 'paymentStatus',
    name: 'paymentStatus',
    isSortable: false,
    render: status => (
      <>
        {status === 'UNPAID' ? (
          <button className='btn btn-success'>{locales('pay')}</button>
        ) : (
          <span className='text-muted'>{locales('tables.paid')}</span>
        )}
      </>
    ),
  },
  {
    title: 'وضعیت کافه',
    dataIndex: 'cafeStatus',
    name: 'cafeStatus',
    isSortable: false,
    render: scheduleStatus => (
      <div className={renderStatusColors(scheduleStatus)}>
        {enumHelper.convertEnumValueToTitle(
          ENUMS.CAFE_STATUS.list,
          scheduleStatus,
        )}
      </div>
    ),
  },
];
